import { render, staticRenderFns } from "./Detail-Group.vue?vue&type=template&id=c233a4a0&"
import script from "./Detail-Group.vue?vue&type=script&lang=js&"
export * from "./Detail-Group.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports